import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
// 动态路由生成工具将在需要时通过store调用

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { 
      title: '登录',
      hideInMenu: true 
    }
  },
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/',
    name: 'AdminLayout',
    component: () => import('@/layouts/AdminLayout.vue'),
    redirect: '/dashboard',
    meta: { requiresAuth: true },
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/Dashboard.vue'),
        meta: { 
          title: '控制台',
          requiresAuth: true 
        }
      },
      {
        path: 'user/list',
        name: 'UserList',
        component: () => import('@/views/user-management/UserList.vue'),
        meta: { 
          title: '用户列表',
          requiresAuth: true 
        }
      },
      {
        path: 'supplier/list',
        name: 'SupplierList',
        component: () => import('@/views/supplier-management/SupplierList.vue'),
        meta: { 
          title: '供应商列表',
          requiresAuth: true 
        }
      },
      {
        path: 'proxy/dynamic-residential',
        name: 'DynamicProxy',
        component: () => import('@/views/proxy-management/DynamicProxy.vue'),
        meta: { 
          title: '动态代理',
          requiresAuth: true 
        }
      },
      {
        path: 'proxy/static-residential',
        name: 'StaticResidentialProxy',
        component: () => import('@/views/proxy-management/StaticResidentialProxy.vue'),
        meta: { 
          title: '静态住宅代理',
          requiresAuth: true 
        }
      },
      {
        path: 'proxy/static-datacenter',
        name: 'StaticDatacenterProxy',
        component: () => import('@/views/proxy-management/StaticDatacenterProxy.vue'),
        meta: { 
          title: '静态数据中心代理',
          requiresAuth: true 
        }
      },
      {
        path: 'maintenance/region',
        name: 'RegionManagement',
        component: () => import('@/views/maintenance-management/RegionManagement.vue'),
        meta: { 
          title: '地区管理',
          requiresAuth: true 
        }
      },
      {
        path: 'maintenance/proxy-type',
        name: 'ProxyTypeManagement',
        component: () => import('@/views/maintenance-management/ProxyTypeManagement.vue'),
        meta: { 
          title: '代理类型管理',
          requiresAuth: true 
        }
      },
      {
        path: 'maintenance/dynamic-channel',
        name: 'DynamicChannelManagement',
        component: () => import('@/views/maintenance-management/DynamicChannelManagement.vue'),
        meta: { 
          title: '动态通道管理',
          requiresAuth: true 
        }
      },
      {
        path: 'maintenance/static-proxy-product',
        name: 'StaticProxyProductManagement',
        component: () => import('@/views/maintenance-management/StaticProxyProductManagement.vue'),
        meta: { 
          title: '静态代理产品管理',
          requiresAuth: true 
        }
      },
      {
        path: 'maintenance/menu',
        name: 'MenuManagement',
        component: () => import('@/views/maintenance-management/MenuManagement.vue'),
        meta: { 
          title: '菜单管理',
          requiresAuth: true 
        }
      },
      {
        path: 'order/proxy',
        name: 'ProxyOrders',
        component: () => import('@/views/order-management/ProxyOrders.vue'),
        meta: { 
          title: '代理订单',
          requiresAuth: true 
        }
      },
      {
        path: 'order/recharge',
        name: 'RechargeOrderManagement',
        component: () => import('@/views/order-management/RechargeOrderManagement.vue'),
        meta: { 
          title: '充值订单',
          requiresAuth: true 
        }
      },
      {
        path: 'order/renewal',
        name: 'RenewalOrderManagement',
        component: () => import('@/views/order-management/RenewalOrderManagement.vue'),
        meta: { 
          title: '续期订单',
          requiresAuth: true 
        }
      },
      {
        path: 'ip/records',
        name: 'IpRecords',
        component: () => import('@/views/ip-management/IpRecords.vue'),
        meta: { 
          title: 'IP 记录',
          requiresAuth: true 
        }
      },
      {
        path: 'ip/public-pool',
        name: 'IpPublicPool',
        component: () => import('@/views/ip-management/IpPublicPool.vue'),
        meta: { 
          title: 'IP 公有池',
          requiresAuth: true 
        }
      },
      {
        path: 'ad/resource-position',
        name: 'ResourcePositionManagement',
        component: () => import('@/views/ad-management/ResourcePositionManagement.vue'),
        meta: { 
          title: '资源位管理',
          requiresAuth: true 
        }
      },
      {
        path: 'ad/article',
        name: 'ArticleManagement',
        component: () => import('@/views/ad-management/ArticleManagement.vue'),
        meta: { 
          title: '文章管理',
          requiresAuth: true 
        }
      },
      {
        path: 'seo/config',
        name: 'SEOConfig',
        component: () => import('@/views/seo-management/SEOConfig.vue'),
        meta: { 
          title: 'SEO 配置',
          requiresAuth: true 
        }
      },
      {
        path: 'finance/transaction',
        name: 'TransactionDetails',
        component: () => import('@/views/finance-management/TransactionDetails.vue'),
        meta: { 
          title: '交易明细',
          requiresAuth: true 
        }
      },
      {
        path: 'finance/payment',
        name: 'PaymentDetails',
        component: () => import('@/views/finance-management/PaymentDetails.vue'),
        meta: { 
          title: '支付明细',
          requiresAuth: true 
        }
      },
      {
        path: 'permission/admin',
        name: 'AdminManagement',
        component: () => import('@/views/permission-management/AdminManagement.vue'),
        meta: { 
          title: '管理员管理',
          requiresAuth: true 
        }
      },
      {
        path: 'permission/role',
        name: 'RoleManagement',
        component: () => import('@/views/permission-management/RoleManagement.vue'),
        meta: { 
          title: '角色管理',
          requiresAuth: true 
        }
      },
      {
        path: 'profile',
        name: 'ProfileCenter',
        component: () => import('@/views/ProfileCenter.vue'),
        meta: { 
          title: '个人中心',
          requiresAuth: true 
        }
      },
      // 推荐官管理
      {
        path: 'referral/level',
        name: 'ReferralLevel',
        component: () => import('@/views/referral-management/ReferralLevel.vue'),
        meta: { 
          title: '推荐官等级',
          requiresAuth: true 
        }
      },
      {
        path: 'referral/officer',
        name: 'ReferralOfficer',
        component: () => import('@/views/referral-management/ReferralOfficer.vue'),
        meta: { 
          title: '推荐官列表',
          requiresAuth: true 
        }
      },
      {
        path: 'referral/audit',
        name: 'ReferralAudit',
        component: () => import('@/views/referral-management/ReferralAudit.vue'),
        meta: { 
          title: '推荐官审核',
          requiresAuth: true 
        }
      },
      {
        path: 'referral/details',
        name: 'ReferralDetails',
        component: () => import('@/views/referral-management/ReferralDetails.vue'),
        meta: { 
          title: '推荐明细',
          requiresAuth: true 
        }
      },
      // 财务管理 - 推荐官相关
      {
        path: 'finance/commission-details',
        name: 'CommissionDetails',
        component: () => import('@/views/finance-management/CommissionDetails.vue'),
        meta: { 
          title: '佣金明细',
          requiresAuth: true 
        }
      },
      {
        path: 'finance/withdrawal-management',
        name: 'WithdrawalManagement',
        component: () => import('@/views/finance-management/WithdrawalManagement.vue'),
        meta: { 
          title: '提现管理',
          requiresAuth: true 
        }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 动态路由加载状态标记
let isLoadingDynamicRoutes = false

// 全局前置守卫
router.beforeEach(async (to, from, next) => {
  console.log(`路由导航: ${from.path} -> ${to.path}`)
  
  // 设置页面标题
  if (to.meta.title) {
    document.title = `${to.meta.title} - InstaIP 管理中心`
  } else {
    document.title = 'InstaIP 管理中心'
  }
  
  // 检查路由是否需要认证
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const token = localStorage.getItem('token')
    if (!token) {
      console.log('未找到token，重定向到登录页')
      next('/login')
    } else {
      // 检查是否需要加载动态路由
      // 使用已导入的store实例，如果不存在则尝试从router.app获取（兼容性处理）
      const storeInstance = store || (router.app && router.app.$store)
      
      if (!storeInstance) {
        console.warn('Store 未初始化，跳过动态路由加载')
        next()
        return
      }
      
      const routesLoaded = storeInstance.getters['menu/routesLoaded']
      const currentUser = storeInstance.getters.currentUser
      const lastUserId = storeInstance.state.menu.lastUserId
      
      // 检查是否需要重新加载菜单：
      // 1. 路由未加载
      // 2. 用户切换了（当前用户ID与上次加载菜单的用户ID不同）
      const needReloadMenu = !routesLoaded || (currentUser && lastUserId && currentUser.id !== lastUserId)
      
      if (needReloadMenu) {
        // 检查是否已经在加载动态路由，避免重复加载
        if (isLoadingDynamicRoutes) {
          console.warn('动态路由正在加载中，等待加载完成...')
          // 这里不应该直接 return 或 router.push，而应该放弃当前导航，让重试机制或外部控制
          // 在 Vue Router 3 中，可以使用 next(false) 中断当前导航，或者简单的通过 setTimeout 重新尝试
          setTimeout(() => {
            next({ ...to, replace: true })
          }, 100)
          return
        }
        
        if (!routesLoaded) {
          console.log('动态路由未加载，开始加载...')
        } else {
          console.log('检测到用户切换，重新加载动态路由...')
        }
        
        isLoadingDynamicRoutes = true
        
        try {
          // 加载动态路由
          await store.dispatch('menu/generateDynamicRoutes', router)
          
          console.log('动态路由加载成功，重新导航到目标路由')
          isLoadingDynamicRoutes = false
          
          // 必须使用 next({ ...to, replace: true }) 来确保路由解析完成，并且替换当前历史记录
          next({ ...to, replace: true })
        } catch (error) {
          console.error('加载动态路由失败:', error)
          isLoadingDynamicRoutes = false
          
          // 如果加载失败，清除认证状态并跳转到登录页
          if (store.commit) {
            store.commit('CLEAR_AUTH')
          }
          next('/login')
        }
      } else {
        console.log('动态路由已加载，继续导航')
        next()
      }
    }
  } else {
    console.log('路由无需认证，直接导航')
    next()
  }
})

// 处理路由错误（特别是动态引入组件时 Chunk 加载失败的问题）
// 这是生产环境常见的因为版本更新导致旧文件被清理，浏览器缓存了旧版 index.html 导致加载模块报错的问题
router.onError((error) => {
  console.error('路由导航报错:', error)
  const pattern = /Loading chunk (\d)+ failed/g
  const isChunkLoadFailed = error.message.match(pattern) || 
                            error.message.includes('Failed to fetch dynamically imported module') ||
                            error.message.includes('Importing a module script failed')
  
  if (isChunkLoadFailed) {
    // 检测到 Chunk 加载失败，直接刷新页面以获取最新版本
    console.log('检测到资源版本更新，正在自动刷新页面...')
    window.location.reload()
  }
})

export default router